import { isPlatformBrowser } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { _, LangChangeEvent, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { Subscription } from 'rxjs';
import { ExternalServicesService } from 'src/services/external-services.service';
import { SSRLangService } from './services/ssrlang.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit,OnDestroy{
  private langChangeSubscription!: Subscription;
  private platformId = inject(PLATFORM_ID);
  private cookieSubs: Subscription[] = [];

  constructor(private translate: TranslateService,private renderer:Renderer2,
    private externalServices: ExternalServicesService,private router:Router
    ,private cookieConsentService: NgcCookieConsentService,private ssrLang:SSRLangService){}

  ngOnInit(): void {
    const lang = this.ssrLang.getLang() || this.translate.getCurrentLang()||this.translate.getFallbackLang()||'ar';
    if (isPlatformBrowser(this.platformId)){

      this.externalServices.initExternalServices();

      if (!this.cookieConsentService.hasAnswered()){

        this.cookieSubs.push(this.translate.stream(_('cookie')).subscribe((value)=>{
          if (this.cookieConsentService.getConfig()?.content!=null){
            this.cookieConsentService.getConfig().content!.message = value.message;
            this.cookieConsentService.getConfig().content!.allow = value.allow;
            this.cookieConsentService.getConfig().content!.deny = value.deny;
            
            this.cookieConsentService.destroy();
            this.cookieConsentService.init(this.cookieConsentService.getConfig());
          }
        }));
        this.cookieSubs.push(this.cookieConsentService.popupClose$.subscribe(
          () => {
            this.externalServices.initExternalServices();
            this.cookieConsentService.destroy();
          }));
        }
        else{
            this.cookieConsentService.destroy();
        }
        this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.externalServices.urlChangeEvent(event.urlAfterRedirects);
        }
      });
    }
    
    this.langChangeSubscription = this.translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.setHtmlLang(event.lang);
        this.ssrLang.setLangViaCookie(event.lang);
      }
    );
    this.translate.use(lang);

  }
  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)){
      this.langChangeSubscription?.unsubscribe();
      this.cookieSubs.forEach(element => {
        element.unsubscribe();
      });
    }
  }

  private setHtmlLang(lang: string){
    const htmlEl = this.renderer.selectRootElement('html',true);
    if (lang && typeof document !== 'undefined'){
      this.renderer.setAttribute(htmlEl,'lang',lang);
      switch (lang){
        case 'ar':
          this.renderer.setAttribute(htmlEl,'dir','rtl');
          break;
        case 'en':
          this.renderer.setAttribute(htmlEl,'dir','ltr');
          break;
        default:
          break;
      }
    }
  }
}
